<template>
    <table class="table table-sm">
        <thead>
            <tr>
                <th>Tid</th>
                <th>Händelsetyp</th>
                <th>Kommentar</th>
                <th>Ref</th>
                <th></th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(e, i) in events" :key="i">
                <!-- TODO: Formatering på datum -->
                <td>{{ e.RegTime }}</td>

                <!-- <td>{{ e.name }}</td> -->
                <td>{{ e.EventTypeName }}</td>

                <td style="max-width: 200px">{{ e.Comment }}</td>
                <td>{{ e.BarCode }}</td>
                <td>
                    <div v-if="GetAttachments(e.EventId).length > 0">
                        <span v-for="(ea, i) in GetAttachments(e.EventId)" :key="i" v-on:click="ShowAttachment(ea)">
                            <b-icon-paperclip></b-icon-paperclip>
                            {{ ea.Description }}
                        </span>
                        <br />
                    </div>
                </td>
                <td></td>
            </tr>
        </tbody>
    </table>
</template>
<script>

export default {
    name: 'eventlist',
    props: { events: Array, attachments: Array },
    methods: {
        ShowAttachment(ea) {
            //alert('Show attachment');
            this.$emit('showattachment', ea);
            window.open(ea.Link);
        },
        GetAttachments(eventId) {
            if (eventId)
                if (this.attachments) {
                    return this.attachments.filter(x => x.EventId == eventId);
                }
            return [];
        }
    }
}

</script>